module.exports = __webpack_public_path__ + "static/media/icon-dash-clinicians.95e280b6.png";